module.exports = __webpack_public_path__ + "static/media/delete-red.eaf82263.svg";